import styled from '@emotion/styled'

interface Props {
  disabled?: boolean
}

const FormSuccess = styled.span<Props>(
  (props) => props.theme.fontSmooth,
  (props) => ({
    display: 'block',
    color: props.theme.colors.success,
    fontFamily: props.theme.fonts.families.body,
    fontSize: '12px',
    letterSpacing: '0.3px',
    lineHeight: '16px',
    marginBottom: '1em',
  }),
  (props) =>
    props.disabled && {
      opacity: props.theme.opacities.disabledInput,
    }
)

export default FormSuccess
